
import React, { useEffect, useState } from "react";
import axios from "axios";
import _ from "lodash";
import { connect } from "react-redux";
import IntlUtil from "../helpers/intl-util";
import { AppConfigProps } from "../settings/app-config";
import { AppConstants } from "../settings/app-constants";
import { getWhitelistDomainsData, setClientNavigator, setWhiteListDomains } from "../actions/common-actions";
import ErrorFrame from "../views/error-frame";
import PageLoader from "../../voice-admin/pages/common/helpers/page-loader";

const _axiosSource = axios.CancelToken.source();
const _cancelToken = { cancelToken: _axiosSource.token };
const _intl_ns_common = "common"

const WhiteListDomain = (props) => {

    const [isPageDataFetched, setPageDataFetched] = useState(false);

    useEffect(() => {

        props.setClientNavigator();
        getWhitelistDomains();

        return () => {
            _axiosSource.cancel(
                IntlUtil.getText(
                    _intl_ns_common,
                    "notification.warning.requestCancelled"
                )
            );
        }
    }, []);

    const getWhitelistDomains = async () => {
        setPageDataFetched(false);
        await getWhitelistDomainsData(_cancelToken)
            .then(async (res) => {
                if (
                    res &&
                    res.data &&
                    res.data.records &&
                    res.status === AppConfigProps.httpStatusCode.ok
                ) {
                    let whitelisted = res.data.records.map((val) => val.url);
                    props.setWhiteListDomains(whitelisted);
                    setPageDataFetched(true);
                }
            })
            .catch(async (err) => {
                setPageDataFetched(true);
            })
            .finally(async () => {
                setPageDataFetched(true);
            });
        setPageDataFetched(true);
    };


    const checkIframeWhiteListDomains = () => {
        if ((window.top === window.self) === false) {
            const ancestorOrigin = document.location.ancestorOrigins && document.location.ancestorOrigins.length ? document.location.ancestorOrigins[0] : ''
            const parentUrl = window.location === window.parent.location ? window.location.href : ancestorOrigin || document.referrer || window.location.href
            if (_.includes(props.whitelistDomains, parentUrl.replace(/\/+$/, "")) === false &&
                props.clientNavigator && props.clientNavigator.accessMode !== AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_TEAMS_CLIENT &&
                props.clientNavigator && props.clientNavigator.accessMode !== AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_TEAMS_BROWSER
            ) {
                return false;
            }
        }

        return true
    };

    return (
        <div id="vpa-layout">
            <PageLoader
                status={isPageDataFetched}
                size="medium"
                labelPosition="below"
                label={IntlUtil.getText(
                    _intl_ns_common,
                    "content.loadingInprogress"
                )}
                type="full-center"
            >
                {checkIframeWhiteListDomains() === true ? props.children : <ErrorFrame />}
            </PageLoader>
        </div>
    )

}

const mapStateToProps = (state) => ({
    whitelistDomains: state.appSettings.whitelistDomains,
    clientNavigator: state.appSettings.clientNavigator,
});

const mapActionToProps = {
    setClientNavigator,
    setWhiteListDomains
};

export default connect(mapStateToProps, mapActionToProps)(WhiteListDomain);
